import { TurboModuleRegistry } from "react-native";
var OneNativeSyncStateNativeModule_default = TurboModuleRegistry.getEnforcing("OneNativeSyncState");
export {
  OneNativeSyncStateNativeModule_default as default
};
//# sourceMappingURL=OneNativeSyncStateNativeModule.js.map
